import { BACKEND_PRIVATE } from '@/api/base'
import { WalletGroup } from '@/constants/blockchain'
import { GigTimeTypes } from '@/constants/gig/gigTimeTypes'

interface SendOfferPayload {
  rate: number
  time_value: number | null
  time_type: GigTimeTypes
  deadline: string // in seconds
  freelancer_wallet: string
  group: WalletGroup
  application_id: LX.GigApplication['id']
}

export async function getGigOffer(id: LX.GigOffer['id']) {
  return BACKEND_PRIVATE.get<LX.GigOfferDetails>('/me/gigs/offers/get', { params: { id } })
}

export async function declineOffer({ id, comment }: { id: LX.GigOffer['id']; comment: string }) {
  return BACKEND_PRIVATE.post<void>(`/me/gigs/offers/decline?id=${id}`, { comment })
}

export async function sendOffer(payload: SendOfferPayload) {
  return BACKEND_PRIVATE.post<void>('/me/gigs/offers/send', { payload })
}

export async function applyOffer(id: LX.GigOffer['id']) {
  return BACKEND_PRIVATE.post<void>(`/me/gigs/offers/apply?id=${id}`)
}
